import { isEqual } from "lodash";

export type InventoryAction = "submit" | "approve" | "reject";
type Inventory = { buyer?: any; lastModifiedDate?: string };

export function approvalStatus(data: Inventory) {
  return data.buyer?.statusChange?.status ?? (data.buyer?.releasedToBuyer ? "pending" : "draft");
}

export function inventoryLocked(data: Inventory) {
  return ["pending", "approved"].includes(approvalStatus(data));
}

export function assertInventoryCurrent(expected: Inventory, current: Inventory) {
  if (expected.lastModifiedDate !== current.lastModifiedDate || !isEqual(expected.buyer, current.buyer)) {
    throw new Error("inventory-stale");
  }
}

export function nextApprovalStatus(data: Inventory, action: InventoryAction) {
  const status = approvalStatus(data);
  if (action === "submit" && ["draft", "rejected"].includes(status)) return "pending";
  if (status === "approved" && action === "reject") return "rejected";
  if (status === "pending") {
    if (action === "approve") return "approved";
    if (action === "reject") return "rejected";
  }
  throw new Error("inventory-stale");
}

/** Ordinary edits never replay a decision or a release flag from an open form. */
export function preserveApproval(editedBuyer: any, currentBuyer: any) {
  if (!editedBuyer) return null;
  const sameBuyer = editedBuyer.id === currentBuyer?.id && editedBuyer.userId === currentBuyer?.userId;
  const { statusChange, releasedToBuyer, ...details } = editedBuyer;
  return {
    ...details,
    statusChange: sameBuyer ? currentBuyer?.statusChange ?? null : null,
    releasedToBuyer: sameBuyer ? currentBuyer?.releasedToBuyer ?? false : false,
  };
}
